import { Head, usePage } from '@inertiajs/react'

export default function ScansShow() {
  const { qr_code } = usePage().props

  return (
    <>
      <Head title={`${qr_code.campaign_name || 'Bienvenue'} - ${qr_code.agency.name}`} />

      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
        {/* Header */}
        <div className="bg-white shadow-sm">
          <div className="max-w-4xl mx-auto px-4 py-6">
            <h1 className="text-2xl font-bold text-gray-900">{qr_code.agency.name}</h1>
            {qr_code.agency.website && (
              <a
                href={qr_code.agency.website}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-600 hover:text-blue-800"
              >
                {qr_code.agency.website}
              </a>
            )}
          </div>
        </div>

        {/* Main Content */}
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            {/* Campaign Info */}
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </div>

              {qr_code.campaign_name && (
                <h2 className="text-3xl font-bold text-gray-900 mb-2">
                  {qr_code.campaign_name}
                </h2>
              )}

              {qr_code.property_address && (
                <p className="text-lg text-gray-600 mb-6">
                  {qr_code.property_address}
                </p>
              )}

              {qr_code.property_type && (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                  {qr_code.property_type.charAt(0).toUpperCase() + qr_code.property_type.slice(1)}
                </span>
              )}
            </div>

            {/* CTA Section */}
            <div className="border-t border-gray-200 pt-8 mt-8">
              <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">
                Intéressé par ce bien ?
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {qr_code.agency.phone && (
                  <a
                    href={`tel:${qr_code.agency.phone}`}
                    className="flex items-center justify-center px-6 py-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-medium"
                  >
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    Appeler
                  </a>
                )}

                {qr_code.agency.email && (
                  <a
                    href={`mailto:${qr_code.agency.email}`}
                    className="flex items-center justify-center px-6 py-4 bg-gray-100 text-gray-900 rounded-lg hover:bg-gray-200 transition font-medium"
                  >
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    Email
                  </a>
                )}
              </div>

              {!qr_code.agency.phone && !qr_code.agency.email && (
                <p className="text-center text-gray-500">
                  Contactez notre agence pour plus d'informations
                </p>
              )}
            </div>

            {/* Footer Info */}
            <div className="mt-8 pt-6 border-t border-gray-200 text-center text-sm text-gray-500">
              <p>Merci d'avoir scanné notre QR Code</p>
              <p className="mt-1">Un conseiller vous contactera dans les plus brefs délais</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
